var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20C0 13.7874 0 10.6812 1.01494 8.23089C2.36819 4.96385 4.96385 2.36819 8.23089 1.01494C10.6812 0 13.7874 0 20 0H40C46.2126 0 49.3188 0 51.7691 1.01494C55.0362 2.36819 57.6318 4.96385 58.9851 8.23089C60 10.6812 60 13.7874 60 20V40C60 46.2126 60 49.3188 58.9851 51.7691C57.6318 55.0362 55.0362 57.6318 51.7691 58.9851C49.3188 60 46.2126 60 40 60H20C13.7874 60 10.6812 60 8.23089 58.9851C4.96385 57.6318 2.36819 55.0362 1.01494 51.7691C0 49.3188 0 46.2126 0 40V20ZM21.6667 30.1693C26.269 30.1693 30 26.4383 30 21.8359C30 17.2336 26.269 13.5026 21.6667 13.5026C17.0643 13.5026 13.3333 17.2336 13.3333 21.8359C13.3333 26.4383 17.0643 30.1693 21.6667 30.1693ZM53.3296 39.2458L41.6629 35.0075L28.3296 45.0076L14.9962 41.6743L6.92708 48.2725C7.01116 48.7876 7.10188 49.0601 7.17039 49.2255C7.84701 50.859 9.14484 52.1568 10.7784 52.8335C11.0558 52.9484 11.6347 53.1258 13.1546 53.2295C14.7345 53.3373 16.7988 53.3409 19.9962 53.3409H39.9963C43.1937 53.3409 45.258 53.3373 46.8379 53.2295C48.3578 53.1258 48.9367 52.9484 49.2141 52.8335C50.8477 52.1568 52.1455 50.859 52.8221 49.2255C52.937 48.9481 53.1145 48.3692 53.2182 46.8492C53.326 45.2693 53.3296 43.205 53.3296 40.0075V39.2458Z",
    fillOpacity: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.78d6527dbb8f91823346d60379edf057.svg";
export { ForwardRef as ReactComponent };